export default __webpack_public_path__ + "static/media/fcmp.cacdc596.svg";